// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e8c651b0","453":"11da5fe0","455":"04d199c4"}[chunkId] + ".chunk.js";
};